/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductListAssignmentOperation } from './ProductListAssignmentOperation';
// @ts-ignore
import {
// @ts-ignore
    ProductListAssignmentOperationFromJSON,
// @ts-ignore
    ProductListAssignmentOperationFromJSONTyped,
// @ts-ignore
    ProductListAssignmentOperationToJSON,
} from './ProductListAssignmentOperation';

/**
 * 
 * @export
 * @interface AssignOrUnassignRetailersToProductList
 */
export interface AssignOrUnassignRetailersToProductList {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignOrUnassignRetailersToProductList
     */
    retailerIds: Array<string>;
    /**
     * 
     * @type {ProductListAssignmentOperation}
     * @memberof AssignOrUnassignRetailersToProductList
     */
    operation: ProductListAssignmentOperation;
}

/**
 * Check if a given object implements the AssignOrUnassignRetailersToProductList interface.
 */
// @ts-ignore
export function instanceOfAssignOrUnassignRetailersToProductList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "retailerIds" in value;
    isInstance = isInstance && "operation" in value;

    return isInstance;
}

// @ts-ignore
export function AssignOrUnassignRetailersToProductListFromJSON(json: any): AssignOrUnassignRetailersToProductList {
    return AssignOrUnassignRetailersToProductListFromJSONTyped(json, false);
}

// @ts-ignore
export function AssignOrUnassignRetailersToProductListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignOrUnassignRetailersToProductList {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retailerIds': json['retailer_ids'],
        'operation': ProductListAssignmentOperationFromJSON(json['operation']),
    };
}

// @ts-ignore
export function AssignOrUnassignRetailersToProductListToJSON(value?: AssignOrUnassignRetailersToProductList | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retailer_ids': value.retailerIds,
        'operation': ProductListAssignmentOperationToJSON(value.operation),
    };
}

